import { defineStore } from 'pinia'

export type AbTestResult = {
  isAPattern: boolean
  isBPattern: boolean
}

export type AbGroup = 'A' | 'B' | 'disabled'

export const useAbTestsStore = defineStore('ab_tests', () => {
  const results = ref<Record<string, AbTestResult | null>>({})

  const getResultByName = (testName: string) => computed<AbTestResult | null>(() => results.value[testName] ?? null)

  const getGroupByName = (testName: string) =>
    computed<AbGroup>(() => {
      const result = results.value[testName]
      if (!result) return 'disabled'
      if (result.isAPattern) return 'A'
      if (result.isBPattern) return 'B'
      return 'disabled'
    })

  return {
    results,
    getResultByName,
    getGroupByName
  }
})
